// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bOD26","title":"Header_title__18HB4","left":"Header_left__3K-AY","clinicName":"Header_clinicName__3KOj6"};